module.exports = __webpack_public_path__ + "2ec4937636959ad1d3cc307e531616cc.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/surfboard-s.png
// module id = 1947
// module chunks = 0